import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { LOGIN_PREFIX, SLACK_OAUTH_CALLBACK_PREFIX } from './app-routing-paths';
import { LoginViewComponent } from './modules/login-view/login-view.component';
import { authGuard, canActivateVanguard, loginGuard } from './core/guards/guards';

export const appRoutes: Routes = [
  { path: '', redirectTo: '', pathMatch: 'full' },
  { path: LOGIN_PREFIX, component: LoginViewComponent, canActivate: [loginGuard] },
  {
    path: '',
    canActivate: [authGuard],
    children: [
      {
        path: SLACK_OAUTH_CALLBACK_PREFIX,
        loadChildren: () =>
          import('./modules/slack-oauth-callback/slack-oauth-callback.module').then(
            (m) => m.SlackOauthCallbackModule,
          ),
        canActivate: [canActivateVanguard],
      },
      {
        path: '',
        loadChildren: () =>
          import('./modules/authenticated-view/authenticated-view.module').then(
            (m) => m.AuthenticatedViewModule,
          ),
      },
    ],
  },
  { path: '**', redirectTo: '' },
];
@NgModule({
  imports: [RouterModule.forRoot(appRoutes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
